module.exports = __webpack_public_path__ + "img/carousel2.c6f04f69.webp";